import { HelpArea } from '@/core/domain/helpcenter/HelpAreas/HelpAreas.types';
import { Menu } from 'antd';

import './style.less';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useHelpAreas } from '@/core/domain/helpcenter/HelpAreas/HelpAreas.hooks';

const HelpItemAreasMenu: React.FC = () => {
  const { helpAreaId } = useRouteMatch<{
    helpAreaId: string;
  }>().params;

  const history = useHistory();

  const { data: areas } = useHelpAreas();

  const renderMenuItem = (item: HelpArea, level = 0) => {
    if (item.children?.length) {
      return (
        <Menu.SubMenu
          title={item.name}
          key={String(item.id)}
          style={{ paddingLeft: 0 }}
        >
          {item.children.map((item) => renderMenuItem(item, level + 1))}
        </Menu.SubMenu>
      );
    }

    return (
      <Menu.Item
        key={String(item.id)}
        onClick={() => history.push(`/helpCenter/${item.id}`)}
      >
        {item.name}
      </Menu.Item>
    );
  };

  return (
    <Menu mode="inline" activeKey={helpAreaId} className="help-item-areas-menu">
      {areas?.map((item) => renderMenuItem(item))}
    </Menu>
  );
};

export default HelpItemAreasMenu;
